<ng-container *ngIf="contact$ | async as contact">
  <div class="cta-contact">
    <div class="cta-contact__strip"></div>
    <div class="cta-contact__inner">
      <div class="cta-contact__head">
        <span class="cta-contact__kicker">Atención al cliente</span>
        <h2 class="cta-contact__title">¿Necesita ayuda?</h2>
        <p class="cta-contact__text">Llámenos o escríbanos, estamos para atenderle.</p>
      </div>
      <div class="cta-contact__actions">
        <a [href]="'tel:' + contact.phoneTel" class="cta-contact__btn cta-contact__btn--phone">
          <span class="cta-contact__icon" aria-hidden="true">
            <svg-icon-sprite [src]="'icon-phone'" width="28" height="28"></svg-icon-sprite>
          </span>
          <span class="cta-contact__btn-label">Llamar ahora</span>
          <span class="cta-contact__btn-value">{{ contact.phoneDisplay }}</span>
        </a>
        <a [href]="contact.chatUrl || URL.SUPPORT_CHAT" target="_blank" rel="noopener noreferrer" class="cta-contact__btn cta-contact__btn--chat">
          <span class="cta-contact__icon" aria-hidden="true">
            <svg-icon-sprite [src]="'icon-portal'" width="28" height="28"></svg-icon-sprite>
          </span>
          <span class="cta-contact__btn-label">{{ contact.chatLabel }}</span>
          <span class="cta-contact__btn-value">Centro de ayuda</span>
        </a>
        <button type="button" class="cta-contact__btn cta-contact__btn--chat cta-contact__btn--slaask" (click)="openSlaaskChat()">
          <span class="cta-contact__icon" aria-hidden="true">
            <svg-icon-sprite [src]="'icon-chat'" width="28" height="28"></svg-icon-sprite>
          </span>
          <span class="cta-contact__btn-label">Chat en línea</span>
          <span class="cta-contact__btn-value">Abrir conversación</span>
        </button>
      </div>
    </div>
  </div>
</ng-container>
